import { useContext } from "react";
import PropTypes from "prop-types";
import ModalTemplate from "../../../common/ModalTemplate";
import { Context } from "../../Provider";
import { theme } from "../../../theme";

const DocumentsInHand = ({ setShowDocumentsInHand }) => {
    const { state: { commonSettings } } = useContext(Context);

    const handleCloseTab = () => {
        window.close();
    };

    return (
        <ModalTemplate
            show={true}
            handleClose={() => { }}
            size="lg"
            centered
            title={null}
            body={
                <div className="card card-plain">
                    <div className="card-body p-3">
                        <h5 className={`mb-1 text-gradient text-${theme.main} text-uppercase`}>
                            {commonSettings?.documents_in_hand_certificate_text}
                        </h5>
                        <p className="mt-3">{commonSettings?.documents_in_hand_discription}</p>

                        <h6 className="mt-4 mb-0">Certificates</h6>
                        <p className="mt-0">{commonSettings?.documents_in_hand_certificate_text}</p>

                        <h6 className="mt-4">Documents</h6>
                        {commonSettings?.personal_document_types?.map((type, index) => (
                            <div className="card mb-2">
                                <div className="card-body p-3">
                                    <div className="d-flex justify-content-between ps-0 mb-2 border-radius-lg">
                                        <div className="d-flex align-items-center">
                                            <i className={`material-icons opacity-10 text-${theme.main} me-2`}>
                                                {type.personal_document_type_icon}
                                            </i>
                                            <div className="d-flex flex-column">
                                                <h6 className="mb-1 text-dark text-sm">
                                                    {type.personal_document_type_name}
                                                </h6>
                                                <span className="text-xs">{type.personal_document_type_description || "No description available."}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <p key={index} className="mb-2 d-flex align-items-center">
                                    <i className={`material-icons opacity-10 text-${theme.main} me-2`}>
                                        {type.personal_document_type_icon}
                                    </i>
                                    <b className="me-1">{type.personal_document_type_name}:</b>
                                    <span>{type.personal_document_type_description || "No description available."}</span>
                                </p> */}
                            </div>
                        ))}
                    </div>

                    <div className="card-footer d-flex p-0">
                        <button
                            className={`btn btn-outline-${theme.main} w-50 m-0 rounded-0 btn-sm`}
                            onClick={handleCloseTab}
                        >
                            Close
                        </button>
                        <button
                            className={`btn btn-${theme.main} w-50 m-0 rounded-0 btn-sm`}
                            onClick={() => setShowDocumentsInHand(false)}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            }
            footer={null}
            backdrop="static"
            keyboard={false}
        />
    );
};

DocumentsInHand.propTypes = {
    setShowDocumentsInHand: PropTypes.func.isRequired
};

export default DocumentsInHand;